import { render, staticRenderFns } from "./x-button.vue?vue&type=template&id=713f00f2&scoped=true&"
import script from "./x-button.vue?vue&type=script&lang=js&"
export * from "./x-button.vue?vue&type=script&lang=js&"
import style0 from "./x-button.vue?vue&type=style&index=0&id=713f00f2&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713f00f2",
  null
  
)

export default component.exports